import identity from 'lodash/identity';
import * as types from '../../actions/actionTypes';
import clearCopyStylesStore from './clearCopyStylesStore';
import addItemToSelection from './addItemToSelection';
import removeItemFromSelection from './removeItemFromSelection';
import clearCopyStyleSelection from './clearCopyStyleSelection';
import selectCopySource from './selectCopySource';
import clearValidateItems from './clearValidateItems';
import validateItems from './validateItems';

const actions = {
  [types.copyStyles.CLEAR_STORE]: clearCopyStylesStore,
  [types.copyStyles.CLEAR_SELECTION]: clearCopyStyleSelection,
  [types.copyStyles.ADD_ITEM]: addItemToSelection,
  [types.copyStyles.REMOVE_ITEM]: removeItemFromSelection,
  [types.copyStyles.SET_SOURCE]: selectCopySource,
  [types.copyStyles.VALIDATION]: validateItems,
  [types.copyStyles.CLEAR_VALIDATION]: clearValidateItems,
  '@@INIT': clearCopyStylesStore,
};

const initialState = {
  selection: [],
  source: '',
};

export default (state = initialState, action) => (actions[action.type] || identity)(state, action);
